import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import AuditLogsPage from "./pages/AuditLogsPage";
import AuditLogsByUserPage from "./pages/AuditLogsByUserPage";
import AuditLogsByEndpointPage from "./pages/AuditLogsByEndpointPage";
import ContactQueriesPage from "./pages/ContactQueriesPage";
import "./index.css";

const AUDIT_LOGS_ENABLED = process.env.REACT_APP_AUDITLOGS === "YES";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            {AUDIT_LOGS_ENABLED && <Route path="audit-logs" element={<AuditLogsPage />} />}
            {AUDIT_LOGS_ENABLED && <Route path="audit-logs/by-user" element={<AuditLogsByUserPage />} />}
            {AUDIT_LOGS_ENABLED && <Route path="audit-logs/by-endpoint" element={<AuditLogsByEndpointPage />} />}
            <Route path="contact-queries" element={<ContactQueriesPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
